import * as React from "react";
import { permissionsMenu } from "../../permissions/components/data";

var UserPermissions = function UserPermissions(props) {
  var admin = props.admin;

  var handleGoToPermissions = function handleGoToPermissions() {
    window.location.href = "/admin/permissions?user_id=".concat(admin.id);
  };

  var getPermissionLabel = function getPermissionLabel(code) {
    if (!admin.permissions || admin.permissions.length === 0) return code;
    var permission = admin.permissions.find(function (p) {
      return p.code === code;
    });
    return permission ? permission.label : code;
  };

  var organizePermissionsForTable = function organizePermissionsForTable() {
    var allPermissions = []; // Si es Super Admin, usar todos los permisos disponibles

    if (admin.is_super_admin) {
      permissionsMenu.forEach(function (category) {
        category.actions.forEach(function (action) {
          allPermissions.push({
            category: category.title,
            code: action.code,
            label: getPermissionLabel(action.code),
            title: action.title,
            actionLabels: action.label
          });
        });
      });
    } else {
      // Para ejecutivos normales, solo los permisos asignados
      if (!admin.permissions_code || admin.permissions_code.length === 0) {
        return {
          tableData: {}
        };
      }

      permissionsMenu.forEach(function (category) {
        category.actions.forEach(function (action) {
          var _admin$permissions_co;

          if (((_admin$permissions_co = admin.permissions_code) === null || _admin$permissions_co === void 0 ? void 0 : _admin$permissions_co.indexOf(action.code)) !== -1) {
            allPermissions.push({
              category: category.title,
              code: action.code,
              label: getPermissionLabel(action.code),
              title: action.title,
              actionLabels: action.label
            });
          }
        });
      });
    } // Organizar por tipo de permiso (VER, CREAR, EDITAR, BORRAR, OTROS) y por categoría


    var types = ['VER', 'CREAR', 'EDITAR', 'BORRAR', 'OTROS'];
    var categories = ['Pólizas', 'Endosos', 'Siniestros'];
    var tableData = {};
    types.forEach(function (type) {
      tableData[type] = {};
      categories.forEach(function (category) {
        tableData[type][category] = [];
      });
    });
    allPermissions.forEach(function (perm) {
      var type = perm.title;

      if (tableData[type] && tableData[type][perm.category]) {
        tableData[type][perm.category].push(perm);
      }
    });
    return {
      tableData: tableData,
      categories: categories,
      types: types
    };
  };

  var _organizePermissionsF = organizePermissionsForTable(),
      tableData = _organizePermissionsF.tableData,
      categories = _organizePermissionsF.categories,
      types = _organizePermissionsF.types;

  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, "Permisos del Ejecutivo"))), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, admin.is_super_admin && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-info",
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("h5", null, "Este ejecutivo es Super Admin"), /*#__PURE__*/React.createElement("p", null, "Los super ejecutivos tienen todos los permisos del sistema.")), !tableData || Object.keys(tableData).length === 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-muted"
  }, "Este ejecutivo no tiene permisos asignados."), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: handleGoToPermissions
  }, "Ir a Gesti\xF3n de Permisos")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-bordered"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    style: {
      width: "15%"
    }
  }, "Tipo"), categories.map(function (category) {
    return /*#__PURE__*/React.createElement("th", {
      key: category,
      style: {
        width: "".concat(85 / categories.length, "%")
      }
    }, category);
  }))), /*#__PURE__*/React.createElement("tbody", null, types.map(function (type) {
    var hasAnyPermission = categories.some(function (category) {
      return tableData[type] && tableData[type][category] && tableData[type][category].length > 0;
    });
    if (!hasAnyPermission) return null;
    return /*#__PURE__*/React.createElement("tr", {
      key: type
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, type)), categories.map(function (category) {
      var perms = tableData[type] && tableData[type][category] ? tableData[type][category] : [];
      return /*#__PURE__*/React.createElement("td", {
        key: category
      }, perms.length > 0 ? /*#__PURE__*/React.createElement("ul", {
        style: {
          marginTop: 0,
          marginBottom: 0,
          paddingLeft: "20px"
        }
      }, perms.map(function (permission, permIndex) {
        return permission.actionLabels && permission.actionLabels.map(function (label, labelIndex) {
          return /*#__PURE__*/React.createElement("li", {
            key: "".concat(permIndex, "-").concat(labelIndex),
            style: {
              fontSize: "0.9em"
            }
          }, label);
        });
      })) : /*#__PURE__*/React.createElement("span", {
        className: "text-muted"
      }, "-"));
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "20px",
      paddingTop: "15px",
      borderTop: "1px solid #ddd"
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-muted",
    style: {
      marginBottom: "10px"
    }
  }, "Para modificar los permisos de este ejecutivo, utiliza la secci\xF3n de Permisos."), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: handleGoToPermissions
  }, "Ir a Gesti\xF3n de Permisos")))));
};

export default UserPermissions;